import { SuppliersContainer } from 'components/buyer/suppliers/Suppliers/SuppliersContainer';

export const Suppliers = (): JSX.Element => <SuppliersContainer />;
